import type { FeedPriority } from '@/shared/api'
import { Calendar, CheckSquare, CloudRain, Compass, Flag, Mail, Route, Sparkles, type LucideIcon } from '@/ui/icons'

/**
 * Priority → Badge styling. Only urgent/high surface a badge to keep rows quiet,
 * matching the dashboard.
 */
export const PRIORITY_BADGE: Partial<
  Record<FeedPriority, { label: string; variant: 'destructive' | 'secondary'; className: string }>
> = {
  urgent: { label: 'Urgent', variant: 'destructive', className: 'bg-red-600' },
  high: { label: 'Soon', variant: 'destructive', className: 'bg-destructive' },
}

/** Maps the backend's card.icon key to a rendered icon. Falls back to Compass. */
export const FEED_ICON_MAP: Record<string, LucideIcon> = {
  checklist: CheckSquare,
  calendar: Calendar,
  route: Route,
  weather: CloudRain,
  invite: Mail,
  event: Flag,
  ranger: Sparkles,
}

/** Priority → icon-chip background/foreground. Urgent/high get a destructive tint; everything else neutral. */
export const PRIORITY_ICON_CHIP: Partial<Record<FeedPriority, string>> = {
  urgent: 'bg-red-100 text-red-700 dark:bg-red-950/40 dark:text-red-400',
  high: 'bg-red-100 text-red-700 dark:bg-red-950/40 dark:text-red-400',
}

export const DEFAULT_ICON_CHIP = 'bg-earth-100 text-earth-700 dark:bg-earth-800 dark:text-earth-300'
